export const sodexAccountCategory = 'sodex'

export const networkEvmChainIds: Record<string, number | undefined> = {}

export const networkPolkadotChainIds: Record<string, number | undefined> = {}

export const solanaNetwork = undefined
